import HttpService from '../../../core/rest/http.service';
import { isArray } from "lodash";
export async function loadWhispererSearch(query, structureKeys, showSiteUrl, groupId, endpoint) {
    if (typeof query === "string" && query.length === 0 || query === null) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return Promise.resolve([]);
    }
    if (!endpoint) {
        endpoint = '/search';
        // Note: structureKeys are used if we search services and contacts
        // Note: structureKeys can be used only with endpoint /search, not /search/autocomplete
        // Note: endpoint /search/autocomplete currently has no advantage over /search and can be omitted
        endpoint += isArray(structureKeys) && structureKeys.length ? '' : '/autocomplete';
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return HttpService.get(endpoint, {
        q: query,
        structureKeys,
        showSiteUrl,
        groupId,
        page: 1,
        pageSize: 5
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    }).then(({ results }) => results);
}
export async function loadSearch(query, structureKeys, showSiteUrl, groupId, endpoint, pager) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return HttpService.get(endpoint || '/search', {
        q: query,
        structureKeys,
        showSiteUrl,
        groupId,
        page: pager.page,
        pageSize: pager.perPage
    });
}
